export const LOGIN_URI = `${process.env.REACT_APP_LOGIN_URL}/sign-in`;